import { useState } from "react";

export default function LoginForm({ onSubmit, loading, error }) {
  const [form, setForm] = useState({
    username: "",
    password: "",
    remember: true,
  });

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  }

  return (
    <form
      className="loginForm"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(form);
      }}
    >
      {error && !loading && (
  <div className="loginError">{error}</div>
)}


      <div className="formGroup">
        <label>Nom d'utilisateur</label>
        <input
          type="text"
          name="username"
          placeholder="admin"
          value={form.username}
          onChange={handleChange}
          required
        />
      </div>

      <div className="formGroup">
        <label>Mot de passe</label>
        <input
          type="password"
          name="password"
          placeholder="••••••••"
          value={form.password}
          onChange={handleChange}
          required
        />
      </div>

      <div className="loginOptions">
        <label className="rememberMe">
          <input
            type="checkbox"
            name="remember"
            checked={form.remember}
            onChange={handleChange}
          />
          Se souvenir de moi
        </label>

        <span className="forgot">Mot de passe oublié ?</span>
      </div>

      <button className="loginBtn" disabled={loading}>
        {loading ? "Connexion..." : "Se connecter"}
      </button>
    </form>
  );
}
